import { FC } from "react";
import * as LucideIcons from "lucide-react";
import { LucideIcon as LucideIconType } from "lucide-react";

type IconName = keyof typeof LucideIcons;

interface Props {
    iconName: IconName;
    size?: number;
    onPress?: () => void;
    color?: string;
    strokeWidth?: number;
    className?: string;
}

export const Icon: FC<Props> = ({
    iconName,
    size = 30,
    onPress,
    color,
    strokeWidth,
    className
}) => {
    const LucideIcon = LucideIcons[iconName] as LucideIconType;

    if (!LucideIcon) {
        console.error(`Icon "${iconName}" not found in lucide-react.`);
        return null;
    }

    return (
        <div onClick={onPress} style={{ cursor: onPress ? 'pointer' : 'default' }} className={className}>
            <LucideIcon
                strokeWidth={strokeWidth}
                size={size}
                color={color}
            />
        </div>
    );
};